<template>
  <div>
    <el-button
      icon="el-icon-plus"
      type="primary"
      size="small"
      @click="editItem()"
      v-permission="Auth.instrumentTemplateEdit"
      >添加库存对象</el-button
    >
    <!-- <file-button
      v-permission="template.category == 1 ? Auth.productIE : Auth.instrumentIE"
      obj="product"
      :filter="filter"
      :templateId="template.id"
      @importCallback="importCallback"
    ></file-button> -->
    <el-table
      :data="items"
      border
      size="small"
      class="mt-10"
      v-loading="loading"
      ref="table"
    >
      <el-table-column
        fixed="left"
        align="center"
        label="编码"
        prop="code"
      ></el-table-column>
      <el-table-column
        align="center"
        :label="param.label"
        :prop="param.key"
        v-for="param in template.custom_params"
        :key="param.key + param.label"
        :min-width="labelWidth(param.label)"
      >
        <template slot-scope="scope">
          {{
            scope.row.custom_params.filter((item) => item.label == param.label)
              .length > 0
              ? scope.row.custom_params.filter(
                  (item) => item.label == param.label,
                )[0].value
              : '-'
          }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="备注" prop="remark">
      </el-table-column>
      <el-table-column align="center" label="状态">
        <template slot-scope="scope">
          <ItemStatus
            :status="scope.row.status"
            model="stockProduct"
          ></ItemStatus>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right">
        <template slot-scope="scope">
          <el-popconfirm
            title="确认删除该库存对象吗？"
            @confirm="hanldeDelte(scope.row, scope.$index)"
          >
            <el-link
              slot="reference"
              v-permission="
                template.category == 1
                  ? Auth.productDelete
                  : Auth.instrumentDelete
              "
              type="danger"
              class="font-12 ml-5"
              :underline="false"
              >删除</el-link
            >
          </el-popconfirm>
          <el-link
            type="primary"
            class="font-12 ml-5"
            :underline="false"
            @click="editItem(scope.row, scope.$index)"
            v-permission="
              template.category == 1 ? Auth.productEdit : Auth.instrumentEdit
            "
            >编辑</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="table-footer">
      <el-pagination
        :page-sizes="[10, 20, 50, 100]"
        :page-size="filter.size"
        :current-page.sync="filter.page"
        @size-change="handleSizeChange"
        @current-change="getData"
        layout="total,sizes, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
    <ItemFormer
      :model="model"
      :show.sync="formerVisible"
      @updated="updatedCallback"
    ></ItemFormer>
  </div>
</template>

<script>
import { productList, productDelete } from '@/service/getData'
import ItemFormer from './StockProductFormer'

export default {
  components: {
    ItemFormer,
  },
  props: {
    template: Object,
  },
  data() {
    return {
      items: [],
      total: 0,
      model: {},
      formerVisible: false,
      editIndex: 0,
      loading: false,
      filter: {
        product_template_id: 0,
        page: 1,
        size: 10,
        stock_type: -1,
      },
    }
  },
  computed: {
    labelWidth() {
      return function (label) {
        const canvas = document.createElement('canvas')
        const context = canvas.getContext('2d')
        context.font = '14px Microsoft YaHei'
        const dimension = context.measureText(label)

        let width = dimension.width + 20
        if (width < 90) {
          width = 90
        }
        return width
      }
    },
  },
  created() {
    this.filter.product_template_id = this.template.id
    this.getData()
  },
  methods: {
    async getData() {
      this.$router.replace({
        query: { filter: JSON.stringify(this.filter) },
      })
      let data = this.clone(this.filter)
      data.page -= 1
      this.loading = true
      let res = await productList(data)
      if (res.status == 0) {
        this.items = res.data.list
        this.total = res.data.count
        this.loading = false
      }
    },
    handleSizeChange(size) {
      this.filter.size = size
      this.filter.page = 1
      this.getData()
    },
    async importCallback() {
      this.filter.page = 1
      this.getData()
    },
    editItem(item, index) {
      if (!item) {
        this.editIndex = -1
        this.model = {
          product_template_id: this.template.id,
          code: '',
          name: this.template.name,
          group_name: this.filter.group_name,
          custom_params: this.template.custom_params || [],
          remark: '',
          category: this.template.category,
          code_type: this.template.code_type,
          stock_type: -1,
          status: 1,
        }
      } else {
        this.model = this.clone(item)
        this.model.custom_params = this.copyCustomParam(
          this.template.custom_params,
          item.custom_params,
        )
        this.editIndex = index
      }
      this.formerVisible = true
    },
    updatedCallback(data) {
      if (this.editIndex == -1) {
        this.items.unshift(data)
      } else {
        this.$set(this.items, this.editIndex, data)
      }
    },
    async hanldeDelte(item, index) {
      let res = await productDelete(item.id)
      if (res.code == 0) {
        this.items.splice(index, 1)
      }
    },
  },
}
</script>

<style scoped>
.table-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
</style>